// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__NDS7f","inner":"Footer_inner__2gisK"};